/**
 * Format a timezone like 'America/New_York' as 'America / New York'
 * @param {string} timezone
 * @return {string}
 */
export function formatTimezone (timezone) {
  return timezone
      ? timezone.replace(/\//g, ' / ').replace(/_/g, ' ')
      : ''
}



// WEBPACK FOOTER //
// ./src/utils/formatTimezone.js